import { render, staticRenderFns } from "./DetailTableDrayage.vue?vue&type=template&id=6e731f0f&scoped=true"
import script from "./DetailTableDrayage.vue?vue&type=script&lang=js"
export * from "./DetailTableDrayage.vue?vue&type=script&lang=js"
import style0 from "./DetailTableDrayage.vue?vue&type=style&index=0&id=6e731f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e731f0f",
  null
  
)

export default component.exports